export default defineI18nConfig(() => ({
    precompile: {
        strictMessage: false,
    },
    legacy: false,
    fallbackLocale: 'en',
}))
  